import styled from 'styled-components'
import { IconComponent } from 'LibNeo'

export const Icon = styled(IconComponent)`
	padding-left: 5px;
	overflow: unset;
	svg {
		width: 32px;
		height: 32px;
	}
`
